module.exports = __webpack_public_path__ + "static/media/acai_berry_sponge.422a320c.png";